import React, { ChangeEvent, useState } from 'react';
import { makeStyles, Select, Theme } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { Language } from '../Language';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    backgroundColor: '#212529',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

const Lang = () => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState<Language>(i18n.language as Language);

  let changeLanguage = (event: any) => {
    let language = event.target.value;

    switch (language) {
      case Language.EN:
        setLang(Language.EN);
        i18n.changeLanguage(Language.EN);
        break;
      case Language.FR:
      default:
        setLang(Language.FR);
        i18n.changeLanguage(Language.FR);
        break;
    }
  };

  return (
    <div>
      <div>
        <Select
          labelId="demo-simple-select-required-label"
          id="demo-simple-select-required"
          value={lang}
          onChange={changeLanguage}
        >
          <MenuItem value={Language.FR}>🇫🇷</MenuItem>
          <MenuItem value={Language.EN}>🇬🇧</MenuItem>
        </Select>
      </div>
    </div>
  );
};

export default Lang;
